import apiClient from '../../../shared/services/apiClient';

/** Yeap Access / Verify console API — /api/user/access/*. Returns body.data; throws {error, code}. */
const call = async (p) => {
    try {
        const res = await p;
        const body = res?.data || {};
        if (body.success === false) {
            // eslint-disable-next-line no-throw-literal
            throw { error: body.error || body.message, code: body.code };
        }
        return body.data;
    } catch (e) {
        if (e && !e.response && 'error' in e) throw e;
        const body = e?.response?.data || {};
        // eslint-disable-next-line no-throw-literal
        throw { error: body.error || body.message || e?.message, code: body.code };
    }
};

export const accessApi = {
    overview: (teamId) => call(apiClient.get('/api/user/access', { params: teamId ? { team_id: teamId } : undefined })),
    members: (teamId) => call(apiClient.get(`/api/user/access/teams/${teamId}/members`)),
    invite: (teamId, email, role) => call(apiClient.post(`/api/user/access/teams/${teamId}/members`, { email, role })),
    setRole: (teamId, id, role) => call(apiClient.put(`/api/user/access/teams/${teamId}/members/${id}`, { role })),
    removeMember: (teamId, id) => call(apiClient.delete(`/api/user/access/teams/${teamId}/members/${id}`)),
    acceptInvite: (id) => call(apiClient.post(`/api/user/access/invitations/${id}/accept`)),
    declineInvite: (id) => call(apiClient.post(`/api/user/access/invitations/${id}/decline`)),
    slugCheck: (slug) => call(apiClient.get('/api/user/access/slug-check', { params: { slug } })),
    createTeam: (slug, name) => call(apiClient.post('/api/user/access/team', { slug, name })),
    sso: (org, host, state) => call(apiClient.post('/api/user/access/sso', { org, host, state })),
    seatQuote: (product, seats) => call(apiClient.post('/api/user/access/seats/quote', { product, seats })),
    seats: (product, seats) => call(apiClient.post('/api/user/access/seats', { product, seats })),
    free: (product) => call(apiClient.post('/api/user/access/free', { product })),
    cdnSites: () => call(apiClient.get('/api/user/access/cdn-sites')),
    cdnLink: (id, linked, headers) => call(apiClient.post(`/api/user/access/cdn-sites/${id}`, { linked, headers })),
};
